module.exports = __webpack_public_path__ + "img/calendar-fill.95ceb7a9.svg";